<h3>Thanks, {{ first_name }}!</h3>

<p class="explanation">
  Starry Internet isn’t yet available for your home but we’re working hard to get there soon.<br/><br/>
  Stay tuned for for more information. You’ll be the first to know once we’re heading your way!
</p>

<p class="regards">
  Happy Interneting,<br/>
  Starry
</p>
